'use strict';
import api from 'utils/api';
import Immutable from 'immutable';

const RequestSource = (alt) => {
    return {
        loadRequests: {
            remote() {
                return api.get('basket/licenses?type=all');
            },
            success: alt.getActions('requests').loadRequestsSuccess,
            error: alt.getActions('requests').loadError
        }
    };
};

export default class RequestStore {
    constructor() {
        this.bindActions(this.alt.getActions('requests'));
        this.registerAsync(RequestSource);
        this.requests = Immutable.fromJS([]);
    }

    onLoadRequestsSuccess(data) {
        this.requests = Immutable.fromJS(data);
    }
}



// WEBPACK FOOTER //
// ./app/stores/requestStore.js